const getImageUrl = (url) => {
    let __DEV__ = window.location.hostname === 'localhost';
    let newUrl = url;
    if (url?.startsWith('null')) {
        newUrl = url.replace('null', __DEV__ ? 'http://localhost:4566/fitwith' : 'https://cdn.withme.so')
    }
    return newUrl
};

export default getImageUrl;